<script setup lang="ts">
import {computed, ref} from "vue";

interface Props {
    open?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    open: false
})

const isOpen = ref<boolean>(props.open);

const icon = computed(() => {
    return isOpen.value ? 'mdi-chevron-down' : 'mdi-chevron-right';
})
</script>
<template>
    <v-card
        variant="flat"
        class="my-3"
    >
        <v-card-title class="text-h5 font-weight-bold">
            <v-icon-btn
                :icon="icon"
                rounded="lg"
                icon-size="24"
                size="26"
                class="mr-2"
                @click="isOpen = !isOpen"
            />
            <slot name="title" />
        </v-card-title>
        <v-expand-transition>
            <v-card-text
                v-if="isOpen"
                class="pr-0 pl-10 py-1 bg-white"
            >
                <slot />
            </v-card-text>
        </v-expand-transition>
    </v-card>
</template>

<style scoped>

</style>
